@if (initialized()) {
  <div class="page">
    <div class="container-fluid container-site pt-3">
      <div class="row py-5">
        <div class="col-auto mx-auto">
          <div class="d-flex align-items-center">
            <p class="font-monospace text-gray h1 mb-0 me-3">Liber</p>

            <img src="/img/video_icon_b.webp" alt="Icono" width="40" />
          </div>
        </div>
      </div>

      @for (video of data(); track video.slug) {
        <div class="video-card">
          <div class="row pb-5">
            <div class="col-12 col-md-3 px-0 px-md-2">
              <a
                [routerLink]="['/articulo', video.slug]"
                class="home-video-image"
              >
                <img [src]="video.image | assetFormatter" alt="" />
              </a>
            </div>

            <div class="col-12 col-md-9 pt-3 pt-md-0 px-4 px-md-2">
              <span class="text-uppercase category-badge">{{
                video.subject?.name
              }}</span>

              <h3>
                <a [routerLink]="['/articulo', video.slug]">{{
                  video.title
                }}</a>
              </h3>

              @if (video.subtitle) {
                <p class="mb-0">{{ video.subtitle }}</p>
              }

              @if (video.author) {
                <span class="author-label"
                  >Por
                  {{ video.author.name + " " + video.author.surname }}</span
                >
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
